import React from 'react'

import { Col, Form } from '_zari/core'

import * as UsuarioCrud from 'services/usuario.service'

const UsuarioPage = ({ usuarios, setUsuarios, usuarioSeleccionado, setUsuarioSeleccionado }) => {
  React.useEffect(() => {
    UsuarioCrud.obtenerTodoAsSelect().then(({ data }) => {
      setUsuarios(data)
    })
  }, [setUsuarios])

  return (
    <>
      <Form.Group>
        <Form.Label text='Usuario' htmlFor='select-usuario' md={3} />
        <Col md={6}>
          <Form.Select name='selectUsuario' id='select-usuario' value={usuarioSeleccionado} onChange={e => setUsuarioSeleccionado(e.target.value)}>
            <option value=''>Todos</option>
            {usuarios.map((x, k) => (
              <option key={k} value={x._id}>
                {x.apellidos}, {x.nombres} ({x.username})
              </option>
            ))}
          </Form.Select>
        </Col>
      </Form.Group>
    </>
  )
}

export default UsuarioPage
